module.exports = __webpack_public_path__ + "static/media/urban-partnership-program.a71b8c17.jpg";